/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Table_Primary_ContactInputs */

const en_clients_table_primary_contact = /** @type {(inputs: Clients_Table_Primary_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary contact`)
};

const pt_br2_clients_table_primary_contact = /** @type {(inputs: Clients_Table_Primary_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato principal`)
};

/**
* | output |
* | --- |
* | "Primary contact" |
*
* @param {Clients_Table_Primary_ContactInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_table_primary_contact = /** @type {((inputs?: Clients_Table_Primary_ContactInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Table_Primary_ContactInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_table_primary_contact(inputs)
	return pt_br2_clients_table_primary_contact(inputs)
});